import { EncryptStorage } from "encrypt-storage";

const CART_FIELD_STORAGE_KEY = "PfTxu1vKyVkCqgP_cart_fields";

export const SERIAL_KEY_GEN = (length) => {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;

  for (let i = 0; i < length; i += 1) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const ecxd = new EncryptStorage(CART_FIELD_STORAGE_KEY, {
  prefix: "@D_A_I_T_O_N_N_CART_FIELDS",
  encAlgorithm: "Rabbit",
});

export const evdac = (text) => {
  if (text !== undefined) {
    return ecxd.encryptString(text.toString());
  } else {
    return "";
  }
};
export const dvaac = (text) => {
  return ecxd.decryptString(text);
};

const CART_SECURE_FIELDS = new Set([
  "UP",
  "UD",
  "Qty",
  "Total",
  "ExtraCost",
  "DocDiscount",
  "VAT",
  "TAXID",
  "UDPer",
  "ServiceCharge",
]);

const CHECKOUT_SECURE_FIELDS = new Set([
  "Total",
  "TaxTotal",
  "ServiceCharge",
  "DiscountTotal",
  "RowDiscountTotal",
  "SubTotal",
  "DisplaySubtotal",
  "DiscountPersentage",
  "PromoGuid",
]);

const safeDecrypt = (value) => {
  if (value === undefined || value === null || value === "") {
    return value;
  }

  if (typeof value !== "string") {
    return value;
  }

  try {
    const decryptedValue = dvaac(value);
    const numericValue = Number(decryptedValue);
    return Number.isFinite(numericValue) &&
      String(decryptedValue).trim() !== ""
      ? numericValue
      : decryptedValue;
  } catch (error) {
    return value;
  }
};

const transformSecureFields = (value, secureFields, transformer) => {
  if (Array.isArray(value)) {
    return value.map((item) =>
      transformSecureFields(item, secureFields, transformer),
    );
  }

  if (!value || typeof value !== "object") {
    return value;
  }

  return Object.fromEntries(
    Object.entries(value).map(([key, fieldValue]) => {
      if (key === "Cart") {
        return [key, transformSecureFields(fieldValue, CART_SECURE_FIELDS, transformer)];
      }

      if (secureFields.has(key)) {
        return [key, transformer(fieldValue)];
      }

      if (Array.isArray(fieldValue) || (fieldValue && typeof fieldValue === "object")) {
        return [key, transformSecureFields(fieldValue, secureFields, transformer)];
      }

      return [key, fieldValue];
    }),
  );
};

export const encryptCartStorageData = (cart) =>
  transformSecureFields(cart, CART_SECURE_FIELDS, (value) =>
    value === undefined || value === null ? value : evdac(value),
  );

export const decryptCartStorageData = (cart) =>
  transformSecureFields(cart, CART_SECURE_FIELDS, safeDecrypt);

export const encryptCheckoutStorageData = (checkoutData) =>
  transformSecureFields(checkoutData, CHECKOUT_SECURE_FIELDS, (value) =>
    value === undefined || value === null ? value : evdac(value),
  );

export const decryptCheckoutStorageData = (checkoutData) =>
  transformSecureFields(checkoutData, CHECKOUT_SECURE_FIELDS, safeDecrypt);

export const buildEncryptedValueProps = (value) => ({
  "data-en": "true",
  "data-dt": evdac(value),
});

export const extractEncryptedElementValue = (element) => {
  if (!element) {
    return "";
  }

  const encryptedValue =
    element.getAttribute("data-dt") || element.dataset?.dt || "";

  if (encryptedValue !== "") {
    return safeDecrypt(encryptedValue);
  }

  return element.textContent || "";
};
